<template>
<div class="chapter">
<div class="inner_page">
<section class="cover cover-rw Cover-rw" epub:type="cover"><img alt="cover" src="Images/Burrowes_RespectforChristmas_ebook_INTERIOR.jpg"/></section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?4d8b6af4